import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type PartnerService from 'tio-employee/services/partner';

export default class AuthenticatedReimaginedContactRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare partner: PartnerService;

  async model() {
    const dataSourceInfo = await this.reimaginedData.getDataSourceInfo();
    return { dataSourceInfo };
  }
}
